





































import _ from "lodash";
import Vue from "vue";
export default Vue.extend({
  props: {
    inputData: Object,
    violations: Object,
    paths: Array,
    types: Object,
    phase: String,
    label: String,
    addons: Boolean
  },
  computed: {
    _() {
      return _;
    },
    fieldAttr() {
      let hasViolation = false;
      const violations = [];
      for (const p of this.$props.paths) {
        const v = _.get(this.$props.violations, p);
        if (v) {
          hasViolation = true;
          violations.push(v);
        }
      }
      return {
        label: this.$props.label,
        addons: this.$props.addons,
        type: {
          "is-danger": hasViolation
        },
        message: violations
      };
    },
    fieldTypes() {
      const ret: { [key: string]: string } = {};
      for (const p of this.$props.paths) {
        const t = (this.$props.types || {})[p];
        if (!t) {
          ret[p] = "text";
        } else if (typeof t == "string" || t instanceof String) {
          ret[p] = "" + t;
        } else {
          ret[p] = t.type;
        }
      }
      return ret;
    },
    fieldProps() {
      const ret: { [key: string]: object } = {};
      for (const p of this.$props.paths) {
        const t = (this.$props.types || {})[p];
        if (!t) {
          ret[p] = {};
        } else if (typeof t == "string" || t instanceof String) {
          ret[p] = {};
        } else {
          ret[p] = t.props;
        }
      }
      return ret;
    }
  },
  methods: {
    get(path: string) {
      return _.get(this.$props.inputData, path);
    },
    set(path: string, event: unknown) {
      // _.set(this.$props.inputData, path, event);
      // console.log(path);
      // console.log(event);
      this.$emit("field-input", path, event);
    }
  }
});
